import React, { useState } from "react";
import styled from "styled-components";
import { Box } from "../components/styled/box";
// import crown from "../assets/crown-medium.png";
import { FaCheck } from "react-icons/fa";
import {
  SinglePlan,
  ListContainer,
  List,
  Bottom,
} from "./styles/AllPackages.style";
import { useParams, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getResponseByCountry } from "../redux/payment/payment.slice";
import LoadingDots from "../components/InlineLoader";
import { postSsl } from "../redux/subscription/subscription.utils";
import { LoaderCircle } from "../components/styled/loaders";
import { setCookie } from "../utils/helpers";
import Modal from "../components/Modal";
// import Timeout from '../components/Timeout';

const PackageDetails = () => {
  const dispatch = useDispatch();
  // const [terms, setTerms] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [postLoading, setPostLoading] = useState(false);
  // const [showReqError, setShowReqError] = useState(false);
  // const [promoCode, setPromoCode] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const { items, loading, couponStatus, couponToken, error } = useSelector(
    (state) => state.payment
  );
  // const { theme } = useSelector((state) => state.theme);
  const theme = "dark";
  const { id } = useParams();

  // Manipulating Package data for rendering
  const single_package = items?.items?.find((item) => item.id === parseInt(id));

  const allMethods = Object.values(single_package?.paymentMethods ?? {});

  const newMethods = allMethods.flatMap((method) =>
    Array.isArray(method) ? method : []
  );

  // const iconLogo = window.platform_info?.iconLogo;
  const { state } = useLocation();
  const country = state?.country || "Unknown";
  // const platform = localStorage.getItem("platform");

  // const handleFunction = () => {
  //   setIsModalOpen(false);
  // };

  React.useEffect(() => {
    dispatch(getResponseByCountry(country));
  }, [dispatch, country]);

  const handleSubmit = async (packageInfo) => {
    //console.log('>>>>>>', currentUser, packageInfo);
    console.log(packageInfo);
    // if (!terms) {
    //   setErrorMessage("You have to agree with terms and condition");
    // } else {
    setPostLoading(true);

    setErrorMessage("");
    if (couponToken.length > 0) {
      setCookie("hash", couponToken, 20);
    }
    const response = await postSsl(packageInfo?.type, packageInfo?.productId);
    setPostLoading(false);
    if (response.status === 400) {
      setOpenModal(true);
      setModalContent(response?.data?.message);
    } else {
      response.data && window.location.replace(response.data?.message);
    }
    // try {
    //   const response = await postSsl(packageInfo?.type, packageInfo?.productId);
    //   setPostLoading(false);
    //   response.data && window.location.replace(response.data?.message);
    // } catch (error) {
    //   setPostLoading(false);
    //   const status = error?.response?.data?.status;
    //   (status === 500 || status === 400 || status === 401 || status === 403) && setShowReqError(true);
    // }
    // }
  };

  // const handlePromo = () => {
  //   if (promoCode && promoCode.length > 4) {
  //     dispatch(getResponseByCoupon({ promoCode, country }));
  //   } else {
  //     console.error("No Promo code Applied");
  //   }
  // };

  const closeModal = () => {
    setOpenModal(false);
    setModalContent("");
  };

  if (loading) {
    return <LoadingDots />;
  }
  if (postLoading) {
    return <LoaderCircle />;
  }

  const getColor = (name) => {
    switch (name) {
      case "Daily":
        return "#FFC250";
      case "Weekly":
        return "#F69E45";
      case "Monthly":
        return "#EF7C4F";
      case "Half Yearly":
        return "#eb5e34";
      case "Yearly":
        return "#E30061";
      case "Quarterly":
        return "#F2896D";
      default:
        return name;
    }
  };
  // if (showReqError) {
  //   return (
  //     <Timeout />
  //   )
  // }
  if (single_package?.length < 1)
    return (
      <h2 style={{ textAlign: "center", width: "100%" }}>
        Something went wrong
      </h2>
    );

  return (
    <>
      <Wrapper theme={theme}>
        {/* <ConfirmationModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          text="Payment Successfull "
          handleFunction={handleFunction}
        /> */}
        <div>
          <Modal isOpen={openModal} onClose={closeModal}>
            <p>{modalContent}</p>
          </Modal>
        </div>
        <Container>
          <SinglePlan color={getColor(single_package?.name ?? "—")}>
            <div className="left">
              <span>{single_package?.name ?? "—"}</span>
            </div>
            <div className="right">
              <Box>
                <header>
                  {/* <img className="icon-logo" src={iconLogo || crown} alt="" /> */}
                  <ListContainer>
                    <List>
                      <FaCheck />{" "}
                      <span>{single_package?.name ?? "—"} Subscription</span>
                    </List>
                    <List>
                      <FaCheck /> <span> Ad-Free experience</span>
                    </List>
                    <List>
                      <FaCheck /> <span>Access Exclusive content</span>
                    </List>
                  </ListContainer>
                </header>
              </Box>
              <Bottom>
                <div className="price">
                  <span className="price-text">Price</span>
                  <p className="currency">
                    <span>
                      <span>{single_package?.price ?? "—"}</span>{" "}
                      {single_package?.unit ?? "—"}
                      {couponStatus === "" || couponStatus === "false" ? (
                        <span className="price-additional">
                          {single_package?.priceAdditional ?? "—"}
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </p>
                </div>
                {couponStatus === "" || couponStatus === "false" ? (
                  <Link to="/">
                    {" "}
                    <span className="change-plan">Change plan</span>
                  </Link>
                ) : (
                  ""
                )}
              </Bottom>
            </div>
          </SinglePlan>
          {/* <p className="terms">
            <span>
              <input
                style={{ cursor: "pointer" }}
                type="checkbox"
                id="terms"
                name="terms"
                checked={terms}
                onChange={() => setTerms(!terms)}
              />
            </span>
            <label htmlFor="terms" style={{ cursor: "pointer" }}>
              By Continuing, you are okay with our{" "}
              <a
                href={`https://${platform}/terms-condition`}
                rel="noopener noreferrer"
                target="_blank"
                className="link"
              >
                Terms & condition
              </a>
              ,{" "}
              <a
                href={`https://${platform}/privacy-policy`}
                rel="noopener noreferrer"
                target="_blank"
                className="link"
              >
                Privacy Policy
              </a>
              , and our{" "}
              <a
                href={`https://${platform}/refund-policy`}
                rel="noopener noreferrer"
                target="_blank"
                className="link"
              >
                {" "}
                Refund Policy
              </a>
              .
            </label>
          </p> */}
          <p className="error">{errorMessage}</p>
          <p className="text">Select a payment method</p>

          {/* {
            <PromoWrap couponStatus={couponStatus}>
              {couponStatus === "" || couponStatus === "false" ? (
                <>
                  <input
                    type="text"
                    name="promo"
                    id="promo"
                    onChange={(e) => setPromoCode(e.target.value)}
                    placeholder="Enter promo code if any"
                  />
                  <input type="submit" value="APPLY" onClick={handlePromo} />
                </>
              ) : (
                "You have got discount on this package"
              )}
            </PromoWrap>
          } */}
          {error && error.length > 0 && (
            <p
              style={{
                textAlign: "left",
                width: "65%",
                marginTop: "0.5rem",
                color: "red",
              }}
            >
              Coupon already used!
            </p>
          )}
          {/* {single_package[0].paymentMethods.razorpay?.map((item, index) => {
            return (
              <ActivePayment key={index} onClick={() => handleSubmit(item)}>
                <img
                  className="sslImage"
                  src={`${process.env.REACT_APP_GRAPHIC_URL}${item.operatorLogo}`}
                  alt="RazorPay"
                />
                <span className='pay-btn'>Pay Now</span>
              </ActivePayment>
            );
          })}

          {single_package[0].paymentMethods.bkash?.map((item, index) => {
            return (
              <ActivePayment type={'bkash'} key={index} onClick={() => handleSubmit(item)}>
                <div>
                  <img src={`${process.env.REACT_APP_GRAPHIC_URL}${item.operatorLogo}`} alt="" />
                  <span style={{ marginLeft: '0.5rem' }}>{item?.operatorAdditional}</span>
                </div>
                <span className='pay-btn'>Pay Now</span>
              </ActivePayment>
            );
          })}

          {single_package[0].paymentMethods.nagad?.map((item, index) => {
            return (
              <ActivePayment key={index} onClick={() => handleSubmit(item)}>
                <div>
                  <img
                    className="sslImage"
                    src={`${process.env.REACT_APP_GRAPHIC_URL}${item.operatorLogo}`}
                    alt="Nagad"
                  />
                  <span style={{ marginLeft: '0.5rem' }}>{item?.operatorAdditional}</span>
                </div>
                <span className='pay-btn'>Pay Now</span>
              </ActivePayment>
            );
          })}

          {single_package[0].paymentMethods.sslcommerz?.map((item, index) => {
            return (
              <ActivePayment key={index} onClick={() => handleSubmit(item)}>
                <div>
                  <img
                    className="sslImage"
                    src={`https://img.rockstreamer.com/${process.env.REACT_APP_GRAPHIC_URL}${item.operatorLogo}`}
                    alt=""
                  />
                  <span style={{ marginLeft: '0.5rem' }}>{item?.operatorAdditional}</span>
                </div>
                <span className='pay-btn'>Pay Now</span>
              </ActivePayment>
            );
          })} */}

          {newMethods?.map((innerItem, index) => {
            return (
              <ActivePayment
                key={index}
                onClick={() => handleSubmit(innerItem)}
              >
                <div>
                  <img
                    className="sslImage"
                    src={`https://img.rockstreamer.com/${process.env.REACT_APP_GRAPHIC_URL}${innerItem.operatorLogo}`}
                    alt=""
                  />
                  <span style={{ marginLeft: "0.5rem" }}>
                    {innerItem?.operatorAdditional}
                  </span>
                </div>
                <span className="pay-btn">Pay Now</span>
              </ActivePayment>
            );
          })}

          {/* <SingleMethod>
            <img src={playStore} alt="" />
            <span>In app billing</span>
          </SingleMethod> */}
        </Container>
      </Wrapper>
    </>
  );
};
const Wrapper = styled.div`
  padding: 2rem;
  max-width: 680px;
  background-color: ${(props) =>
    props.theme === "light" ? "var(--off-white)" : "#141e29"};
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  margin: 0 auto;
  margin-bottom: 2rem;
  border: 1px solid #e30061;
  /* color: #fff !important; */
  a {
    color: currentColor;
    text-decoration: none;
  }
  .ssl-banner {
    margin-top: 40px;
    max-width: 100%;
    @media (max-width: 600px) {
      margin-top: 20px;
    }
  }
  .terms {
    font-size: 12px;
    text-align: center;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 30px;
  }
  .link {
    color: var(--button-bg);
  }
  .error {
    font-size: 12px;
    color: #ff3333;
    margin-top: -10px;
  }
  .sslImage {
    height: 30px;
    width: auto;
  }
`;
const Container = styled.div`
  margin: 40px auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 1rem;
  .change-plan {
    color: var(--button-bg);
    font-size: 14px;
    cursor: pointer;
  }
  .text {
    font-size: 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    /* color: #fff !important; */
  }
  .show {
    height: 221px;
    @media (max-width: 600px) {
      height: 150px;
    }
  }
`;

const ActivePayment = styled.div`
  div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pay-btn {
    margin-left: 3rem;
    margin-right: 1rem;
    background-color: var(--button-bg);
    color: #fff;
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-weight: 600;
  }
  cursor: pointer;
  width: 90vw;
  max-width: 512px;
  height: 70px;
  @media (max-width: 600px) {
    height: 53px;
    padding: 1rem 0.5rem;
    .pay-btn {
      margin-left: 0;
      margin-right: 0;
      padding: 0.5rem 0.6rem;
      font-size: 0.8rem;
    }
  }
  border: 1px solid;
  background-color: #000f1e;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.27);
  -webkit-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.27);
  -moz-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.27);
  margin-top: 30px;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  color: #fff;
  img {
    margin-right: ${(props) => (props.type === "bkash" ? "1rem" : "1rem")};
    height: 30px;
    width: 30px;
  }
  @media (max-width: 600px) {
    img {
      margin-right: 0.2rem;
    }
  }
`;
// const PromoWrap = styled.div`
//   border: ${(props) =>
//     props.couponStatus === "" || props.couponStatus === "false"
//       ? "2px solid var(--button-bg)"
//       : "2px solid green"};
//   border-radius: 4px;
//   height: 3rem;
//   width: 70%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   > * {
//     height: 100%;
//     border: none;
//     outline: none;
//   }
//   input[type="text"] {
//     flex: 1;
//     padding: 0.5rem 1rem;
//     font-size: 0.9rem;
//   }
//   input[type="submit"] {
//     padding-left: 2rem;
//     padding-right: 2rem;
//     background: var(--button-bg);
//     color: var(--button-front);
//     font-weight: 600;
//     cursor: pointer;
//     transition: transform 250ms ease-in-out;
//     backface-visibility: hidden;
//   }
//   input[type="submit"]:hover {
//     transform: scale(1.055);
//     border-radius: 4px;
//   }
//   @media (max-width: 600px) {
//     width: auto;
//     input[type="submit"] {
//       font-size: 0.8rem;
//     }
//   }
// `;
export default PackageDetails;
